import API from 'utils/api';
import getFormattedValues, { formatReceived, hasFiles } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'recaudacion/vehiculos/';
const files = [
  'comprobante_de_domicilio',
  'factura_del_vehiculo',
  'pedimento_del_vehiculo',
];
const headers = { 'Content-Type': 'multipart/form-data' };

/**
 * GET Vehiculos
 * @param {object} params
 * @returns {Promise<object>}
 */
export const getVehiculos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return { ...response.data, results: formatReceived(response.data.results) };
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Vehiculo
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getVehiculo = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Vehiculo
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postVehiculo = async (values) => {
  try {
    const config = hasFiles(values, files) ? { headers } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: true,
    });
    const response = await API.post(baseURI, formattedValues, config);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST Vehiculo Usado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postVehiculoUsado = async (values) => {
  try {
    const config = hasFiles(values, files) ? { headers } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: true,
    });
    const response = await API.post(`${baseURI}registro-usado`, formattedValues, config);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST Vehiculo Nuevo
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postVehiculoNuevo = async (values) => {
  try {
    const config = hasFiles(values, files) ? { headers } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: true,
    });
    const response = await API.post(`${baseURI}registro-nuevo`, formattedValues, config);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Vehiculo
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchVehiculo = async (id, values, clean = true) => {
  try {
    const config = hasFiles(values, files) ? { headers } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean,
    });
    const response = await API.patch(`${baseURI}${id}`, formattedValues, config);
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Vehiculo
 * @param {number} id
 * @param {number} idVehiculo
 * @returns {Promise<object|boolean>}
 */
export const deleteVehiculo = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Formato de alta vehicular
 * @param {object} values
 * @param {number} values.vehiculo_id
 * @param {number} values.motocicleta_id
 * @param {number} values.remolque_id
 * @param {number} tramite
 * @returns {Promise<object|boolean>}
 */
export const getFormatoTramitePDF = async (values) => {
  try {
    const response = await API.post('recaudacion/vehiculo/pdf', values);
    const base64 = `data:application/pdf;base64,${response.data.pdf}`;
    return base64;
  } catch (err) {
    onError(err);
    return null;
  }
};
